import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProBadge from "@/components/ProBadge";
import { ArrowLeft, Award, Heart, MessageSquare, MapPin, HandHeart } from "lucide-react";

export default function NeighborProfile() {
  const { userId } = useParams();
  const [p, setP] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => {
    api.get(`/entre-voisins/helpers/${userId}`).then((r) => setP(r.data)).catch(() => setNf(true));
  }, [userId]);

  if (nf) return <div className="max-w-2xl mx-auto px-4 py-20 text-center text-slate-500">Voisin introuvable. <Link to="/entre-voisins" className="text-[#E05638] font-semibold">← Entre Voisins</Link></div>;
  if (!p) return <div className="max-w-2xl mx-auto px-4 py-20 text-center text-slate-400">Chargement…</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 py-8" data-testid="voisin-profile-page">
      <Link to="/entre-voisins" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#E05638] hover:underline"><ArrowLeft size={15} /> Entre Voisins</Link>

      <div className="mt-4 bg-white rounded-2xl border border-slate-200 p-6 text-center">
        <div className="w-16 h-16 rounded-full bg-[#E05638]/10 text-[#E05638] grid place-items-center mx-auto text-2xl font-bold">{(p.name || "?").charAt(0).toUpperCase()}</div>
        <h1 className="mt-3 font-heading text-2xl font-extrabold text-slate-900 flex items-center justify-center gap-2">{p.name} {p.is_pro && <ProBadge size="sm" />}</h1>
        {p.city && <div className="text-sm text-slate-500 mt-1 inline-flex items-center gap-1"><MapPin size={13} /> {p.city}</div>}
        <div className="mt-5 grid grid-cols-3 gap-3">
          <div className="bg-rose-50 rounded-xl p-3" data-testid="voisin-profile-thanks">
            <div className="text-2xl font-extrabold text-rose-600 flex items-center justify-center gap-1"><Heart size={18} className="fill-rose-500" /> {p.thanks_count}</div>
            <div className="text-xs text-slate-600 mt-0.5">remerciement{p.thanks_count > 1 ? "s" : ""}</div>
          </div>
          <div className="bg-orange-50 rounded-xl p-3">
            <div className="text-2xl font-extrabold text-[#E05638] flex items-center justify-center gap-1"><HandHeart size={18} /> {p.replies_count}</div>
            <div className="text-xs text-slate-600 mt-0.5">coups de main proposés</div>
          </div>
          <div className="bg-slate-50 rounded-xl p-3">
            <div className="text-2xl font-extrabold text-slate-700 flex items-center justify-center gap-1"><MessageSquare size={18} /> {p.posts_count}</div>
            <div className="text-xs text-slate-600 mt-0.5">annonce{p.posts_count > 1 ? "s" : ""}</div>
          </div>
        </div>
      </div>

      {p.notes.length > 0 && (
        <div className="mt-6">
          <h2 className="font-heading text-lg font-bold text-slate-900 flex items-center gap-2"><Award size={18} className="text-[#E05638]" /> Remerciements reçus</h2>
          <div className="mt-3 space-y-2">
            {p.notes.map((n, i) => (
              <div key={i} className="bg-white rounded-xl border border-slate-200 p-3" data-testid={`voisin-profile-note-${i}`}>
                <p className="text-sm text-slate-700 italic">« {n.note} »</p>
                {n.post_title && <p className="text-xs text-slate-400 mt-1">à propos de « {n.post_title} »</p>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
